import { Trans } from '@lingui/react/macro'
import { Text } from 'designSystem/components/Text'
import React from 'react'

export type PageMetadataEvalLabeledByBadgeProps = {
  labeledBy: string
}

/** Browse labeled → All has no single labeler, so this names whoever labeled the page on screen. */
export function PageMetadataEvalLabeledByBadge({
  labeledBy,
}: PageMetadataEvalLabeledByBadgeProps): React.ReactElement {
  return (
    <Text variant='caption' color='muted'>
      <Trans>Labeled by {labeledBy}</Trans>
    </Text>
  )
}
